<!--  -->
<template>
  <div class="backTop" v-if="btnFlag" :style="{bottom:(bottom?'450px':'100px')}">
    <img src="../img/backtop.png" @click="backTop" />
  </div>
</template>

<script>
  //这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
  //例如：import 《组件名称》 from '《组件路径》';

  export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
      //这里存放数据
      return {
        btnFlag: false,
        bottom: false
      };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
      // 点击图片回到顶部方法，加计时器是为了过渡顺滑
      backTop() {
        const that = this;
        let timer = setInterval(() => {
          let ispeed = Math.floor(-that.scrollTop / 5);
          document.documentElement.scrollTop = document.body.scrollTop =
            that.scrollTop + ispeed;
          if (that.scrollTop === 0) {
            clearInterval(timer);
          }
        }, 16);
      },

      // 为了计算距离顶部的高度，当高度大于60显示回顶部图标，小于60则隐藏
      scrollToTop() {
        const that = this;
        let scrollTop =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop;
        that.scrollTop = scrollTop;
        if (that.scrollTop > 600) {
          that.btnFlag = true;
        } else {
          that.btnFlag = false;
        }
        var bottom =
          document.documentElement.scrollHeight -
          document.documentElement.scrollTop;
        if (bottom > 1000) {
          that.bottom = false;
        } else {
          that.bottom = true;
        }
      }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {},
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
      window.addEventListener("scroll", this.scrollToTop);
    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {
      window.removeEventListener("scroll", this.scrollToTop);
    }, //生命周期 - 销毁完成
    activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
  };

</script>
<style scoped>
  .backTop {
    width: 70px;
    height: 70px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 10px 10px 0px rgba(0, 0, 0, 0.2);
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    right: 24%;
    z-index: 100;
  }

  .backTop img {
    width: 26px;
    height: 30px;
  }

</style>



// WEBPACK FOOTER //
// src/components/Backtop.vue